import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState, useEffect } from "react";
import ThemeToggler from "../ThemeToggler";
import menuData from "../menuData";
import { useTranslation } from 'react-i18next';

const HeaderDesktop = ({ sticky }: { sticky: boolean }) => {
  const { t, i18n } = useTranslation('translation');
  const translate = (key) => {
    return t(key) || key;
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // Submenu handler
  const [openIndex, setOpenIndex] = useState(-1);
  const handleSubmenu = (index) => {
    if (openIndex === index) {
      setOpenIndex(-1);
    } else {
      setOpenIndex(index);
    }
  };

  const pathname = usePathname();

  return (
    <div className="container">
      <div className="relative -mx-4 flex items-center justify-between">
        <div className="w-60 max-w-full px-4 xl:mr-12">
          <Link
            href="/"
            className={`header-logo block w-full ${
              sticky ? "py-5 lg:py-2" : "py-8"
            } `}
          >
            <Image
              src="/images/logo/logo-2.png"
              alt="logo"
              width={204}
              height={40}
              priority
              className="w-full dark:hidden"
            />
            <Image
              src="/images/logo/logo.png"
              alt="logo"
              width={204}
              height={40}
              priority
              className="hidden w-full dark:block"
            />
          </Link>
        </div>
        <div className="flex w-full items-center justify-between px-4">
          <div>
            <nav
              id="navbarCollapse"
              className="navbar lg:visible lg:static lg:w-auto lg:border-none lg:!bg-transparent lg:p-0 lg:opacity-100"
            >
              <ul className="lg:flex lg:space-x-12">
                {menuData.map((menuItem, index) => (
                  <li key={index} className="group relative">
                    {menuItem.path ? (
                      <Link
                        href={menuItem.path}
                        className={`flex py-2 text-base lg:mr-0 lg:inline-flex lg:px-0 lg:py-6 ${
                          pathname === menuItem.path
                            ? "text-primary dark:text-white"
                            : "text-dark hover:text-primary dark:text-white/70 dark:hover:text-white"
                        }`}        
                      >
                        {translate(menuItem.title)} 
                      </Link>
                    ) : (
                      <>
                        <p
                          onClick={() => handleSubmenu(index)}
                          className="flex cursor-pointer items-center justify-between py-2 text-base text-dark group-hover:text-primary dark:text-white/70 dark:group-hover:text-white lg:mr-0 lg:inline-flex lg:px-0 lg:py-6"                    
                        >
                          {translate(menuItem.title)} 
                          <span className="pl-3">
                            <svg width="25" height="24" viewBox="0 0 25 24">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M6.29289 8.8427C6.68342 8.45217 7.31658 8.45217 7.70711 8.8427L12 13.1356L16.2929 8.8427C16.6834 8.45217 17.3166 8.45217 17.7071 8.8427C18.0976 9.23322 18.0976 9.86639 17.7071 10.2569L12 15.964L6.29289 10.2569C5.90237 9.86639 5.90237 9.23322 6.29289 8.8427Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                        </p>
                        <div
                          className={`submenu relative left-0 top-full rounded-sm bg-white transition-[top] duration-300 group-hover:opacity-100 dark:bg-dark lg:invisible lg:absolute lg:top-[110%] lg:block lg:w-[250px] lg:p-4 lg:opacity-0 lg:shadow-lg lg:group-hover:visible lg:group-hover:top-full ${
                            openIndex === index ? "block" : "hidden"
                          }`}
                        >
                          {menuItem.submenu?.map((submenuItem, index) => (
                            submenuItem.path && (
                              <Link
                                href={submenuItem.path}
                                key={index}
                                className="block rounded py-2.5 text-sm text-dark hover:text-primary dark:text-white/70 dark:hover:text-white lg:px-3"                                
                              >
                                {translate(submenuItem.title)} 
                              </Link>
                            )
                          ))}
                        </div>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          </div>
          <div className="flex items-center justify-end pr-16 lg:pr-0">
            <div>
              <ThemeToggler />
            </div>
            <button
              onClick={() => changeLanguage(i18n.language === 'fr' ? 'en' : 'fr')}
              className="ml-4 rounded bg-primary px-4 py-2 text-white"
            >
              {i18n.language === 'fr' ? 'EN' : 'FR'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderDesktop; 